import React from 'react';
import { Alert, AlertIcon, AlertTitle } from '@chakra-ui/react';
import { getStrings } from '../../../../../../common/utils';

export const VoidedRaceBanner = () => {
  const [{ Generic }] = getStrings();

  return (
    <Alert status="error">
      <AlertIcon />

      <AlertTitle>{Generic.RaceVoid}</AlertTitle>
    </Alert>
  );
};
